export enum PhoneType {
    HOME = 'HOME',
    PROFESSIONAL = 'PROFESSIONAL',
    CELLULAR = 'CELLULAR',
    OTHER = 'OTHER',
}